// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-page {
  min-height: 100vh;
  background: #f6f8fa;
  padding: 80px 24px 48px;
}

.checkout-container {
  max-width: 1080px;
  margin: 0 auto;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #5ea1d8;
  text-decoration: none;
  font-size: 0.9375rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
  transition: color 0.2s;
}
.back-link .material-icons {
  font-size: 1.125rem;
}
.back-link:hover {
  color: #4a92c8;
}

.checkout-grid {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 2rem;
  align-items: start;
}

.order-summary {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  padding: 2rem;
}

.summary-header {
  margin-bottom: 1.5rem;
}

.plan-badge {
  display: inline-block;
  background: rgba(94, 161, 216, 0.12);
  color: #4a92c8;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0.3rem 0.75rem;
  border-radius: 999px;
  margin-bottom: 0.75rem;
}
.plan-badge.growth {
  background: rgba(94, 161, 216, 0.18);
  color: #3b82c4;
}
.plan-badge.creator {
  background: rgba(94, 161, 216, 0.14);
  color: #4a92c8;
}

.summary-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 0.5rem;
  line-height: 1.25;
}

.summary-desc {
  font-size: 1rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}

.selector-group {
  margin-bottom: 1.5rem;
}

.selector-label {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #9ca3af;
  margin: 0 0 0.625rem;
}

.plan-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.plan-card-option {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  padding: 1rem 1.125rem 1rem 2.5rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: #fafbfc;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
}
.plan-card-option .radio-dot {
  position: absolute;
  left: 1rem;
  top: 1.125rem;
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  transition: all 0.2s;
}
.plan-card-option .radio-dot::after {
  content: "";
  position: absolute;
  inset: 3px;
  border-radius: 50%;
  background: transparent;
  transition: background 0.2s;
}
.plan-card-option .plan-card-name {
  font-size: 1rem;
  font-weight: 700;
  color: #374151;
  line-height: 1.2;
}
.plan-card-option .plan-card-price {
  font-size: 1.125rem;
  font-weight: 700;
  color: #111827;
}
.plan-card-option .plan-card-price small {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #6b7280;
}
.plan-card-option:hover:not(.selected) {
  border-color: #c7d9ea;
  background: #fff;
}
.plan-card-option.selected {
  border-color: #5ea1d8;
  background: linear-gradient(135deg, rgba(94, 161, 216, 0.08) 0%, rgba(94, 161, 216, 0.02) 100%);
  box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.15);
}
.plan-card-option.selected .radio-dot {
  border-color: #5ea1d8;
}
.plan-card-option.selected .radio-dot::after {
  background: #5ea1d8;
}
.plan-card-option.selected .plan-card-name {
  color: #111827;
}
.plan-card-option.growth-option.selected {
  border-color: #3b82c4;
  background: linear-gradient(135deg, rgba(59, 130, 196, 0.1) 0%, rgba(94, 161, 216, 0.04) 100%);
}

.popular-ribbon {
  position: absolute;
  top: -1px;
  right: 12px;
  background: linear-gradient(135deg, #5ea1d8, #3b82c4);
  color: #fff;
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 0.2rem 0.55rem;
  border-radius: 0 0 6px 6px;
  line-height: 1.3;
}

.billing-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.billing-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
  padding: 0.875rem 1rem 0.875rem 2.5rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: #fafbfc;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
}
.billing-card .radio-dot {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  transition: all 0.2s;
}
.billing-card .radio-dot::after {
  content: "";
  position: absolute;
  inset: 3px;
  border-radius: 50%;
  background: transparent;
  transition: background 0.2s;
}
.billing-card .billing-card-name {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #374151;
}
.billing-card .billing-card-detail {
  font-size: 0.75rem;
  color: #9ca3af;
  line-height: 1.3;
}
.billing-card:hover:not(.selected) {
  border-color: #c7d9ea;
  background: #fff;
}
.billing-card.selected {
  border-color: #5ea1d8;
  background: rgba(94, 161, 216, 0.06);
  box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.12);
}
.billing-card.selected .radio-dot {
  border-color: #5ea1d8;
}
.billing-card.selected .radio-dot::after {
  background: #5ea1d8;
}
.billing-card.selected .billing-card-name {
  color: #111827;
}
.billing-card.selected .billing-card-detail {
  color: #6b7280;
}
.billing-card.annual-card.selected {
  border-color: #15803d;
  background: linear-gradient(135deg, rgba(21, 128, 61, 0.06) 0%, rgba(94, 161, 216, 0.04) 100%);
  box-shadow: 0 0 0 1px rgba(21, 128, 61, 0.15);
}
.billing-card.annual-card.selected .radio-dot {
  border-color: #15803d;
}
.billing-card.annual-card.selected .radio-dot::after {
  background: #15803d;
}

.save-ribbon {
  position: absolute;
  top: -1px;
  right: 12px;
  background: #15803d;
  color: #fff;
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0.2rem 0.5rem;
  border-radius: 0 0 6px 6px;
  line-height: 1.3;
}

.included-section {
  margin-bottom: 1.75rem;
  padding-bottom: 1.75rem;
  border-bottom: 1px solid #e5e7eb;
}

.included-heading {
  font-size: 0.8125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #9ca3af;
  margin: 0 0 1rem;
}

.benefit-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 0.875rem;
}

.benefit-icon {
  font-size: 1.25rem;
  color: #5ea1d8;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.benefit-text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.benefit-label {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #111827;
}

.benefit-detail {
  font-size: 0.8125rem;
  color: #6b7280;
  line-height: 1.4;
}

.order-breakdown {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.breakdown-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9375rem;
  color: #374151;
}
.breakdown-row.savings {
  color: #15803d;
  font-weight: 500;
}
.breakdown-row.total {
  margin-top: 0.5rem;
  padding-top: 0.875rem;
  border-top: 1px solid #e5e7eb;
  font-weight: 700;
  font-size: 1.0625rem;
  color: #111827;
}
.breakdown-row.total .total-amount {
  font-size: 1.25rem;
  color: #111827;
}
.breakdown-row.total .total-amount--free {
  color: #15803d;
}

.order-breakdown--trial .breakdown-row.total .total-amount--free {
  color: #15803d;
}

.billing-note {
  font-size: 0.8125rem;
  color: #9ca3af;
  margin: 0.5rem 0 0;
  line-height: 1.4;
}

.payment-panel {
  position: sticky;
  top: 80px;
}

.payment-card {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  padding: 1.75rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
}

.payment-header {
  margin-bottom: 1.25rem;
}

.payment-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 0.25rem;
}

.payment-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}

.account-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #f9fafb;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  margin-bottom: 1.25rem;
}
.account-info .material-icons {
  font-size: 1.5rem;
  color: #9ca3af;
}
.account-info .account-label {
  display: block;
  font-size: 0.75rem;
  color: #9ca3af;
  font-weight: 500;
}
.account-info .account-email {
  display: block;
  font-size: 0.875rem;
  color: #111827;
  font-weight: 600;
  word-break: break-all;
}

.payment-summary {
  background: #f9fafb;
  border-radius: 10px;
  padding: 1rem 1.125rem;
  margin-bottom: 1.25rem;
}

.payment-plan-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.75rem;
  margin-bottom: 0.875rem;
  padding-bottom: 0.875rem;
  border-bottom: 1px solid #e5e7eb;
}

.payment-plan-name {
  font-weight: 700;
  color: #111827;
  font-size: 1rem;
}

.payment-plan-meta {
  font-size: 0.8125rem;
  color: #6b7280;
  white-space: nowrap;
}

.payment-breakdown {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.payment-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  color: #374151;
}
.payment-line .struck {
  text-decoration: line-through;
  color: #9ca3af;
}
.payment-line.discount {
  color: #15803d;
  font-weight: 500;
}
.payment-line.discount .discount-amount {
  font-weight: 700;
}
.payment-line.total {
  margin-top: 0.375rem;
  padding-top: 0.75rem;
  border-top: 1px dashed #e5e7eb;
  font-weight: 700;
  font-size: 1rem;
  color: #111827;
}
.payment-line.total .payment-total {
  font-size: 1.25rem;
}

.payment-savings-note {
  margin: 0.75rem 0 0;
  padding: 0.5rem 0.75rem;
  background: #dcfce7;
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #15803d;
  text-align: center;
}

.paypal-section {
  margin-bottom: 1.25rem;
  min-height: 48px;
}

.trust-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}
.trust-list li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8125rem;
  color: #6b7280;
}
.trust-list li .material-icons {
  font-size: 1rem;
  color: #9ca3af;
}

:host-context(body.theme-dark) .checkout-page {
  background: #0a0c10;
}
:host-context(body.theme-dark) .order-summary,
:host-context(body.theme-dark) .payment-card {
  background: #111827;
  border-color: rgba(148, 163, 184, 0.2);
}
:host-context(body.theme-dark) .summary-title,
:host-context(body.theme-dark) .payment-title,
:host-context(body.theme-dark) .benefit-label,
:host-context(body.theme-dark) .breakdown-row.total,
:host-context(body.theme-dark) .payment-plan-row,
:host-context(body.theme-dark) .account-email {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .summary-desc,
:host-context(body.theme-dark) .benefit-detail,
:host-context(body.theme-dark) .payment-subtitle,
:host-context(body.theme-dark) .payment-plan-meta,
:host-context(body.theme-dark) .billing-note {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .selector-label {
  color: #64748b;
}
:host-context(body.theme-dark) .plan-card-option,
:host-context(body.theme-dark) .billing-card {
  background: #1e293b;
  border-color: rgba(148, 163, 184, 0.25);
}
:host-context(body.theme-dark) .plan-card-option .plan-card-name,
:host-context(body.theme-dark) .plan-card-option .billing-card-name,
:host-context(body.theme-dark) .billing-card .plan-card-name,
:host-context(body.theme-dark) .billing-card .billing-card-name {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .plan-card-option .plan-card-price,
:host-context(body.theme-dark) .billing-card .plan-card-price {
  color: #f8fafc;
}
:host-context(body.theme-dark) .plan-card-option .plan-card-price small,
:host-context(body.theme-dark) .billing-card .plan-card-price small {
  color: #94a3b8;
}
:host-context(body.theme-dark) .plan-card-option .billing-card-detail,
:host-context(body.theme-dark) .billing-card .billing-card-detail {
  color: #64748b;
}
:host-context(body.theme-dark) .plan-card-option:hover:not(.selected),
:host-context(body.theme-dark) .billing-card:hover:not(.selected) {
  background: #243044;
  border-color: rgba(94, 161, 216, 0.35);
}
:host-context(body.theme-dark) .plan-card-option.selected,
:host-context(body.theme-dark) .billing-card.selected {
  background: rgba(94, 161, 216, 0.12);
  border-color: #5ea1d8;
}
:host-context(body.theme-dark) .plan-card-option.selected .plan-card-name,
:host-context(body.theme-dark) .plan-card-option.selected .billing-card-name,
:host-context(body.theme-dark) .billing-card.selected .plan-card-name,
:host-context(body.theme-dark) .billing-card.selected .billing-card-name {
  color: #f8fafc;
}
:host-context(body.theme-dark) .plan-card-option.annual-card.selected,
:host-context(body.theme-dark) .billing-card.annual-card.selected {
  background: rgba(21, 128, 61, 0.12);
  border-color: #22c55e;
}
:host-context(body.theme-dark) .included-section,
:host-context(body.theme-dark) .breakdown-row.total {
  border-color: rgba(148, 163, 184, 0.2);
}
:host-context(body.theme-dark) .included-section--trial {
  background: rgba(22, 163, 74, 0.12);
  border-color: rgba(74, 222, 128, 0.28);
}
:host-context(body.theme-dark) .included-section--trial .included-heading,
:host-context(body.theme-dark) .included-section--trial .benefit-icon {
  color: #86efac !important;
}
:host-context(body.theme-dark) .trial-after-note {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .total-amount--free,
:host-context(body.theme-dark) .payment-total--free {
  color: #86efac !important;
}
:host-context(body.theme-dark) .trial-pay-note {
  color: #86efac !important;
}
:host-context(body.theme-dark) .paypal-trial-unavailable {
  background: rgba(245, 158, 11, 0.12);
  border-color: rgba(245, 158, 11, 0.35);
  color: #fbbf24;
}
:host-context(body.theme-dark) .breakdown-row {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .account-info,
:host-context(body.theme-dark) .payment-summary {
  background: #1e293b;
}
:host-context(body.theme-dark) .payment-plan-row {
  border-color: rgba(148, 163, 184, 0.2);
}
:host-context(body.theme-dark) .payment-line {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .payment-line.total {
  border-color: rgba(148, 163, 184, 0.2);
  color: #f8fafc;
}
:host-context(body.theme-dark) .payment-savings-note {
  background: rgba(21, 128, 61, 0.15);
  color: #4ade80;
}
:host-context(body.theme-dark) .trust-list li {
  color: #94a3b8;
}
:host-context(body.theme-dark) .trust-list li .material-icons {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .included-heading,
:host-context(body.theme-dark) .account-label,
:host-context(body.theme-dark) .payment-plan-name,
:host-context(body.theme-dark) .payment-plan-meta {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .back-link {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .plan-badge {
  background: rgba(94, 161, 216, 0.2) !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .order-summary,
:host-context(body.theme-dark) .payment-card,
:host-context(body.theme-dark) .account-info,
:host-context(body.theme-dark) .payment-summary,
:host-context(body.theme-dark) .plan-card-option,
:host-context(body.theme-dark) .billing-card {
  background: #111827 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .checkout-page {
  background: #0a0c10 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .checkout-page h1,
:host-context(body.theme-dark) .checkout-page h2,
:host-context(body.theme-dark) .checkout-page p,
:host-context(body.theme-dark) .checkout-page span,
:host-context(body.theme-dark) .checkout-page li,
:host-context(body.theme-dark) .checkout-page label {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .summary-desc,
:host-context(body.theme-dark) .benefit-detail,
:host-context(body.theme-dark) .payment-subtitle,
:host-context(body.theme-dark) .billing-note,
:host-context(body.theme-dark) .selector-label,
:host-context(body.theme-dark) .billing-card-detail {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .summary-title,
:host-context(body.theme-dark) .payment-title,
:host-context(body.theme-dark) .benefit-label,
:host-context(body.theme-dark) .account-email,
:host-context(body.theme-dark) .plan-card-name,
:host-context(body.theme-dark) .billing-card-name,
:host-context(body.theme-dark) .plan-card-price,
:host-context(body.theme-dark) .breakdown-row.total,
:host-context(body.theme-dark) .payment-line.total {
  color: #f8fafc !important;
}

@media (max-width: 900px) {
  .checkout-grid {
    grid-template-columns: 1fr;
  }
  .payment-panel {
    position: static;
  }
}
@media (max-width: 600px) {
  .checkout-page {
    padding: 72px 16px 32px;
  }
  .order-summary,
  .payment-card {
    padding: 1.25rem;
  }
  .summary-title {
    font-size: 1.375rem;
  }
  .plan-cards,
  .billing-cards {
    grid-template-columns: 1fr;
  }
}
.trial-badge {
  display: inline-block;
  margin: 0 0 0.75rem 0.5rem;
  padding: 0.3rem 0.75rem;
  border-radius: 999px;
  background: #dcfce7;
  color: #166534;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.trial-desc {
  margin: 0.75rem 0 0;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  background: rgba(94, 161, 216, 0.08);
  color: #374151;
  font-size: 0.9rem;
  line-height: 1.5;
}

.included-section--trial {
  padding: 1rem 1.1rem;
  border-radius: 12px;
  border: 1px solid rgba(22, 163, 74, 0.22);
  background: rgba(220, 252, 231, 0.45);
}
.included-section--trial .included-heading {
  color: #166534;
}
.included-section--trial .benefit-icon {
  color: #15803d;
}

.trial-after-note {
  margin: 0.85rem 0 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: #6b7280;
}

.payment-total--free {
  color: #15803d !important;
}

.trial-pay-note {
  color: #166534 !important;
}

.paypal-trial-unavailable {
  margin: 0;
  padding: 0.9rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(217, 119, 6, 0.35);
  background: #fffbeb;
  color: #92400e;
  font-size: 0.875rem;
  line-height: 1.45;
}

.trial-consent {
  display: flex;
  gap: 0.6rem;
  align-items: flex-start;
  margin: 1rem 0;
  font-size: 0.85rem;
  line-height: 1.45;
  color: #374151;
  cursor: pointer;
}
.trial-consent input {
  margin-top: 0.2rem;
  flex-shrink: 0;
}

.trial-manage-panel {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin-bottom: 1.25rem;
  padding: 0.9rem 1.1rem;
  border: 1px solid rgba(94, 161, 216, 0.35);
  border-radius: 12px;
  background: rgba(94, 161, 216, 0.08);
}
.trial-manage-panel .material-icons {
  color: #4a92c8;
}
.trial-manage-panel .trial-manage-text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  flex: 1;
  font-size: 0.9rem;
  color: #374151;
}
.trial-manage-panel .trial-cancel-btn {
  border: 1px solid #d1d5db;
  background: #fff;
  color: #b91c1c;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
}
.trial-manage-panel .trial-cancel-btn.emphasis {
  border-color: #b91c1c;
}
.trial-manage-panel .trial-cancel-btn:disabled {
  opacity: 0.6;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/subscriptions/subscriptions.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,cAAA;AAAJ;;AAIA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;AADF;;AAKA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;AAFF;;AAKA;EACE,qBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;AAFF;AAIE;EACE,oCAAA;EACA,cAAA;AAFJ;AAKE;EACE,oCAAA;EACA,cAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAJF;;AAOA;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAJF;;AAOA;EACE,qBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;AAJF;;AAQA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AALF;;AAQA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,kCAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,+DAAA;AALF;AAOE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AALJ;AAOI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;AALN;AASE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAPJ;AAUE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AARJ;AAUI;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;AARN;AAYE;EACE,qBAAA;EACA,gBAAA;AAVJ;AAaE;EACE,qBAAA;EACA,+FAAA;EACA,8CAAA;AAXJ;AAaI;EACE,qBAAA;AAXN;AAaM;EACE,mBAAA;AAXR;AAeI;EACE,cAAA;AAbN;AAiBE;EACE,qBAAA;EACA,8FAAA;AAfJ;;AAmBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,qDAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AAhBF;;AAoBA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,sCAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,+DAAA;AAjBF;AAmBE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AAjBJ;AAmBI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;AAjBN;AAqBE;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;AAnBJ;AAsBE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AApBJ;AAuBE;EACE,qBAAA;EACA,gBAAA;AArBJ;AAwBE;EACE,qBAAA;EACA,oCAAA;EACA,8CAAA;AAtBJ;AAwBI;EACE,qBAAA;AAtBN;AAwBM;EACE,mBAAA;AAtBR;AA0BI;EACE,cAAA;AAxBN;AA2BI;EACE,cAAA;AAzBN;AA6BE;EACE,qBAAA;EACA,8FAAA;EACA,6CAAA;AA3BJ;AA6BI;EACE,qBAAA;AA3BN;AA6BM;EACE,mBAAA;AA3BR;;AAiCA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,sBAAA;EACA,uBAAA;EACA,gCAAA;AA9BF;;AAiCA;EACE,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,oBAAA;EACA,cAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;AA9BF;AAgCE;EACE,cAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AA/BJ;AAiCI;EACE,kBAAA;EACA,cAAA;AA/BN;AAiCM;EACE,cAAA;AA/BR;;AAqCA;EACE,cAAA;AAlCF;;AAqCA;EACE,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAlCF;;AAsCA;EACE,gBAAA;EACA,SAAA;AAnCF;;AAsCA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,0CAAA;AAnCF;;AAsCA;EACE,sBAAA;AAnCF;;AAsCA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAnCF;;AAsCA;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AAnCF;;AAsCA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AAnCF;AAqCE;EACE,iBAAA;EACA,cAAA;AAnCJ;AAsCE;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AApCJ;AAuCE;EACE,cAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AArCJ;;AAyCA;EACE,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,wBAAA;EACA,gCAAA;AAtCF;;AAyCA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAtCF;;AAyCA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAtCF;AAwCE;EACE,6BAAA;EACA,cAAA;AAtCJ;AAyCE;EACE,cAAA;EACA,gBAAA;AAvCJ;AAyCI;EACE,gBAAA;AAvCN;AA2CE;EACE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAzCJ;AA2CI;EACE,kBAAA;AAzCN;;AA8CA;EACE,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA3CF;;AA8CA;EACE,sBAAA;EACA,gBAAA;AA3CF;;AA8CA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AA3CF;AA6CE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;AA3CJ;AA6CI;EACE,eAAA;EACA,cAAA;AA3CN;;AAkDE;EACE,mBAAA;AA/CJ;AAkDE;;EAEE,mBAAA;EACA,sCAAA;AAhDJ;AAmDE;;;;;;EAME,yBAAA;AAjDJ;AAoDE;;;;;EAKE,yBAAA;AAlDJ;AAqDE;EACE,cAAA;AAnDJ;AAsDE;;EAEE,mBAAA;EACA,uCAAA;AApDJ;AAsDI;;;;EAEE,cAAA;AAlDN;AAqDI;;EACE,cAAA;AAlDN;AAoDM;;EACE,cAAA;AAjDR;AAqDI;;EACE,cAAA;AAlDN;AAqDI;;EACE,mBAAA;EACA,sCAAA;AAlDN;AAqDI;;EACE,oCAAA;EACA,qBAAA;AAlDN;AAoDM;;;;EAEE,cAAA;AAhDR;AAoDI;;EACE,mCAAA;EACA,qBAAA;AAjDN;AAqDE;;EAEE,sCAAA;AAnDJ;AAsDE;EACE,mCAAA;EACA,sCAAA;AApDJ;AAsDI;;EAEE,yBAAA;AApDN;AAwDE;EACE,yBAAA;AAtDJ;AAyDE;;EAEE,yBAAA;AAvDJ;AA0DE;EACE,yBAAA;AAxDJ;AA2DE;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AAzDJ;AA4DE;EACE,cAAA;AA1DJ;AA6DE;;EAEE,mBAAA;AA3DJ;AA8DE;EACE,sCAAA;AA5DJ;AA+DE;EACE,cAAA;AA7DJ;AA+DI;EACE,sCAAA;EACA,cAAA;AA7DN;AAiEE;EACE,mCAAA;EACA,cAAA;AA/DJ;AAkEE;EACE,cAAA;AAhEJ;AAkEI;EACE,yBAAA;AAhEN;AAoEE;;;;EAIE,yBAAA;AAlEJ;AAqEE;EACE,yBAAA;AAnEJ;AAsEE;EACE,8CAAA;EACA,yBAAA;AApEJ;AAuEE;;;;;;EAME,8BAAA;EACA,yBAAA;AArEJ;AAwEE;EACE,8BAAA;EACA,yBAAA;AAtEJ;AAyEE;;;;;;EAME,yBAAA;AAvEJ;AA0EE;;;;;;EAME,yBAAA;AAxEJ;AA2EE;;;;;;;;;EASE,yBAAA;AAzEJ;;AA8EA;EACE;IACE,0BAAA;EA3EF;EA8EA;IACE,gBAAA;EA5EF;AACF;AA+EA;EACE;IACE,uBAAA;EA7EF;EAgFA;;IAEE,gBAAA;EA9EF;EAiFA;IACE,mBAAA;EA/EF;EAkFA;;IAEE,0BAAA;EAhFF;AACF;AAmFA;EACE,qBAAA;EACA,0BAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAjFF;;AAoFA;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oCAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAjFF;;AAoFA;EACE,oBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qCAAA;AAjFF;AAmFE;EACE,cAAA;AAjFJ;AAoFE;EACE,cAAA;AAlFJ;;AAsFA;EACE,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;AAnFF;;AAsFA;EACE,yBAAA;AAnFF;;AAsFA;EACE,yBAAA;AAnFF;;AAsFA;EACE,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,yCAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAnFF;;AAsFA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAnFF;AAqFE;EACE,kBAAA;EACA,cAAA;AAnFJ;;AAuFA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,0CAAA;EACA,mBAAA;EACA,oCAAA;AApFF;AAsFE;EACE,cAAA;AApFJ;AAuFE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;EACA,iBAAA;EACA,cAAA;AArFJ;AAwFE;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;AAtFJ;AAwFI;EACE,qBAAA;AAtFN;AAyFI;EACE,YAAA;EACA,eAAA;AAvFN","sourcesContent":[".checkout-page {\n  min-height: 100vh;\n  background: #f6f8fa;\n  padding: calc(56px + 24px) 24px 48px;\n}\n\n.checkout-container {\n  max-width: 1080px;\n  margin: 0 auto;\n}\n\n.back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  color: #5ea1d8;\n  text-decoration: none;\n  font-size: 0.9375rem;\n  font-weight: 500;\n  margin-bottom: 1.5rem;\n  transition: color 0.2s;\n\n  .material-icons {\n    font-size: 1.125rem;\n  }\n\n  &:hover {\n    color: #4a92c8;\n  }\n}\n\n.checkout-grid {\n  display: grid;\n  grid-template-columns: 1fr 400px;\n  gap: 2rem;\n  align-items: start;\n}\n\n// ── Left: Order summary ──\n.order-summary {\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid #e5e7eb;\n  padding: 2rem;\n}\n\n.summary-header {\n  margin-bottom: 1.5rem;\n}\n\n.plan-badge {\n  display: inline-block;\n  background: rgba(94, 161, 216, 0.12);\n  color: #4a92c8;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 0.3rem 0.75rem;\n  border-radius: 999px;\n  margin-bottom: 0.75rem;\n\n  &.growth {\n    background: rgba(94, 161, 216, 0.18);\n    color: #3b82c4;\n  }\n\n  &.creator {\n    background: rgba(94, 161, 216, 0.14);\n    color: #4a92c8;\n  }\n}\n\n.summary-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 0.5rem;\n  line-height: 1.25;\n}\n\n.summary-desc {\n  font-size: 1rem;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.selector-group {\n  margin-bottom: 1.5rem;\n}\n\n.selector-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #9ca3af;\n  margin: 0 0 0.625rem;\n}\n\n// Plan card selector\n.plan-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n\n.plan-card-option {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n  padding: 1rem 1.125rem 1rem 2.5rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fafbfc;\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;\n\n  .radio-dot {\n    position: absolute;\n    left: 1rem;\n    top: 1.125rem;\n    width: 18px;\n    height: 18px;\n    border: 2px solid #d1d5db;\n    border-radius: 50%;\n    transition: all 0.2s;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      inset: 3px;\n      border-radius: 50%;\n      background: transparent;\n      transition: background 0.2s;\n    }\n  }\n\n  .plan-card-name {\n    font-size: 1rem;\n    font-weight: 700;\n    color: #374151;\n    line-height: 1.2;\n  }\n\n  .plan-card-price {\n    font-size: 1.125rem;\n    font-weight: 700;\n    color: #111827;\n\n    small {\n      font-size: 0.8125rem;\n      font-weight: 500;\n      color: #6b7280;\n    }\n  }\n\n  &:hover:not(.selected) {\n    border-color: #c7d9ea;\n    background: #fff;\n  }\n\n  &.selected {\n    border-color: #5ea1d8;\n    background: linear-gradient(135deg, rgba(94, 161, 216, 0.08) 0%, rgba(94, 161, 216, 0.02) 100%);\n    box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.15);\n\n    .radio-dot {\n      border-color: #5ea1d8;\n\n      &::after {\n        background: #5ea1d8;\n      }\n    }\n\n    .plan-card-name {\n      color: #111827;\n    }\n  }\n\n  &.growth-option.selected {\n    border-color: #3b82c4;\n    background: linear-gradient(135deg, rgba(59, 130, 196, 0.1) 0%, rgba(94, 161, 216, 0.04) 100%);\n  }\n}\n\n.popular-ribbon {\n  position: absolute;\n  top: -1px;\n  right: 12px;\n  background: linear-gradient(135deg, #5ea1d8, #3b82c4);\n  color: #fff;\n  font-size: 0.625rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding: 0.2rem 0.55rem;\n  border-radius: 0 0 6px 6px;\n  line-height: 1.3;\n}\n\n// Billing card selector\n.billing-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n\n.billing-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.15rem;\n  padding: 0.875rem 1rem 0.875rem 2.5rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fafbfc;\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;\n\n  .radio-dot {\n    position: absolute;\n    left: 1rem;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 18px;\n    height: 18px;\n    border: 2px solid #d1d5db;\n    border-radius: 50%;\n    transition: all 0.2s;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      inset: 3px;\n      border-radius: 50%;\n      background: transparent;\n      transition: background 0.2s;\n    }\n  }\n\n  .billing-card-name {\n    font-size: 0.9375rem;\n    font-weight: 700;\n    color: #374151;\n  }\n\n  .billing-card-detail {\n    font-size: 0.75rem;\n    color: #9ca3af;\n    line-height: 1.3;\n  }\n\n  &:hover:not(.selected) {\n    border-color: #c7d9ea;\n    background: #fff;\n  }\n\n  &.selected {\n    border-color: #5ea1d8;\n    background: rgba(94, 161, 216, 0.06);\n    box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.12);\n\n    .radio-dot {\n      border-color: #5ea1d8;\n\n      &::after {\n        background: #5ea1d8;\n      }\n    }\n\n    .billing-card-name {\n      color: #111827;\n    }\n\n    .billing-card-detail {\n      color: #6b7280;\n    }\n  }\n\n  &.annual-card.selected {\n    border-color: #15803d;\n    background: linear-gradient(135deg, rgba(21, 128, 61, 0.06) 0%, rgba(94, 161, 216, 0.04) 100%);\n    box-shadow: 0 0 0 1px rgba(21, 128, 61, 0.15);\n\n    .radio-dot {\n      border-color: #15803d;\n\n      &::after {\n        background: #15803d;\n      }\n    }\n  }\n}\n\n.save-ribbon {\n  position: absolute;\n  top: -1px;\n  right: 12px;\n  background: #15803d;\n  color: #fff;\n  font-size: 0.625rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 0.2rem 0.5rem;\n  border-radius: 0 0 6px 6px;\n  line-height: 1.3;\n}\n\n.included-section {\n  margin-bottom: 1.75rem;\n  padding-bottom: 1.75rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.included-heading {\n  font-size: 0.8125rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #9ca3af;\n  margin: 0 0 1rem;\n}\n\n.benefit-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.benefit-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.875rem;\n}\n\n.benefit-icon {\n  font-size: 1.25rem;\n  color: #5ea1d8;\n  flex-shrink: 0;\n  margin-top: 0.1rem;\n}\n\n.benefit-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.benefit-label {\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #111827;\n}\n\n.benefit-detail {\n  font-size: 0.8125rem;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.order-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n}\n\n.breakdown-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.9375rem;\n  color: #374151;\n\n  &.savings {\n    color: #15803d;\n    font-weight: 500;\n  }\n\n  &.total {\n    margin-top: 0.5rem;\n    padding-top: 0.875rem;\n    border-top: 1px solid #e5e7eb;\n    font-weight: 700;\n    font-size: 1.0625rem;\n    color: #111827;\n\n    .total-amount {\n      font-size: 1.25rem;\n      color: #111827;\n\n      &--free {\n        color: #15803d;\n      }\n    }\n  }\n}\n\n.order-breakdown--trial .breakdown-row.total .total-amount--free {\n  color: #15803d;\n}\n\n.billing-note {\n  font-size: 0.8125rem;\n  color: #9ca3af;\n  margin: 0.5rem 0 0;\n  line-height: 1.4;\n}\n\n// ── Right: Payment panel ──\n.payment-panel {\n  position: sticky;\n  top: calc(56px + 24px);\n}\n\n.payment-card {\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid #e5e7eb;\n  padding: 1.75rem;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);\n}\n\n.payment-header {\n  margin-bottom: 1.25rem;\n}\n\n.payment-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 0.25rem;\n}\n\n.payment-subtitle {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin: 0;\n}\n\n.account-info {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: #f9fafb;\n  border-radius: 10px;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1.25rem;\n\n  .material-icons {\n    font-size: 1.5rem;\n    color: #9ca3af;\n  }\n\n  .account-label {\n    display: block;\n    font-size: 0.75rem;\n    color: #9ca3af;\n    font-weight: 500;\n  }\n\n  .account-email {\n    display: block;\n    font-size: 0.875rem;\n    color: #111827;\n    font-weight: 600;\n    word-break: break-all;\n  }\n}\n\n.payment-summary {\n  background: #f9fafb;\n  border-radius: 10px;\n  padding: 1rem 1.125rem;\n  margin-bottom: 1.25rem;\n}\n\n.payment-plan-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 0.75rem;\n  margin-bottom: 0.875rem;\n  padding-bottom: 0.875rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.payment-plan-name {\n  font-weight: 700;\n  color: #111827;\n  font-size: 1rem;\n}\n\n.payment-plan-meta {\n  font-size: 0.8125rem;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n.payment-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.payment-line {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.875rem;\n  color: #374151;\n\n  .struck {\n    text-decoration: line-through;\n    color: #9ca3af;\n  }\n\n  &.discount {\n    color: #15803d;\n    font-weight: 500;\n\n    .discount-amount {\n      font-weight: 700;\n    }\n  }\n\n  &.total {\n    margin-top: 0.375rem;\n    padding-top: 0.75rem;\n    border-top: 1px dashed #e5e7eb;\n    font-weight: 700;\n    font-size: 1rem;\n    color: #111827;\n\n    .payment-total {\n      font-size: 1.25rem;\n    }\n  }\n}\n\n.payment-savings-note {\n  margin: 0.75rem 0 0;\n  padding: 0.5rem 0.75rem;\n  background: #dcfce7;\n  border-radius: 8px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #15803d;\n  text-align: center;\n}\n\n.paypal-section {\n  margin-bottom: 1.25rem;\n  min-height: 48px;\n}\n\n.trust-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n\n  li {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.8125rem;\n    color: #6b7280;\n\n    .material-icons {\n      font-size: 1rem;\n      color: #9ca3af;\n    }\n  }\n}\n\n// ── Dark mode ──\n:host-context(body.theme-dark) {\n  .checkout-page {\n    background: #0a0c10;\n  }\n\n  .order-summary,\n  .payment-card {\n    background: #111827;\n    border-color: rgba(148, 163, 184, 0.2);\n  }\n\n  .summary-title,\n  .payment-title,\n  .benefit-label,\n  .breakdown-row.total,\n  .payment-plan-row,\n  .account-email {\n    color: #f8fafc !important;\n  }\n\n  .summary-desc,\n  .benefit-detail,\n  .payment-subtitle,\n  .payment-plan-meta,\n  .billing-note {\n    color: #94a3b8 !important;\n  }\n\n  .selector-label {\n    color: #64748b;\n  }\n\n  .plan-card-option,\n  .billing-card {\n    background: #1e293b;\n    border-color: rgba(148, 163, 184, 0.25);\n\n    .plan-card-name,\n    .billing-card-name {\n      color: #cbd5e1;\n    }\n\n    .plan-card-price {\n      color: #f8fafc;\n\n      small {\n        color: #94a3b8;\n      }\n    }\n\n    .billing-card-detail {\n      color: #64748b;\n    }\n\n    &:hover:not(.selected) {\n      background: #243044;\n      border-color: rgba(94, 161, 216, 0.35);\n    }\n\n    &.selected {\n      background: rgba(94, 161, 216, 0.12);\n      border-color: #5ea1d8;\n\n      .plan-card-name,\n      .billing-card-name {\n        color: #f8fafc;\n      }\n    }\n\n    &.annual-card.selected {\n      background: rgba(21, 128, 61, 0.12);\n      border-color: #22c55e;\n    }\n  }\n\n  .included-section,\n  .breakdown-row.total {\n    border-color: rgba(148, 163, 184, 0.2);\n  }\n\n  .included-section--trial {\n    background: rgba(22, 163, 74, 0.12);\n    border-color: rgba(74, 222, 128, 0.28);\n\n    .included-heading,\n    .benefit-icon {\n      color: #86efac !important;\n    }\n  }\n\n  .trial-after-note {\n    color: #94a3b8 !important;\n  }\n\n  .total-amount--free,\n  .payment-total--free {\n    color: #86efac !important;\n  }\n\n  .trial-pay-note {\n    color: #86efac !important;\n  }\n\n  .paypal-trial-unavailable {\n    background: rgba(245, 158, 11, 0.12);\n    border-color: rgba(245, 158, 11, 0.35);\n    color: #fbbf24;\n  }\n\n  .breakdown-row {\n    color: #cbd5e1;\n  }\n\n  .account-info,\n  .payment-summary {\n    background: #1e293b;\n  }\n\n  .payment-plan-row {\n    border-color: rgba(148, 163, 184, 0.2);\n  }\n\n  .payment-line {\n    color: #cbd5e1;\n\n    &.total {\n      border-color: rgba(148, 163, 184, 0.2);\n      color: #f8fafc;\n    }\n  }\n\n  .payment-savings-note {\n    background: rgba(21, 128, 61, 0.15);\n    color: #4ade80;\n  }\n\n  .trust-list li {\n    color: #94a3b8;\n\n    .material-icons {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .included-heading,\n  .account-label,\n  .payment-plan-name,\n  .payment-plan-meta {\n    color: #cbd5e1 !important;\n  }\n\n  .back-link {\n    color: #93c5fd !important;\n  }\n\n  .plan-badge {\n    background: rgba(94, 161, 216, 0.2) !important;\n    color: #93c5fd !important;\n  }\n\n  .order-summary,\n  .payment-card,\n  .account-info,\n  .payment-summary,\n  .plan-card-option,\n  .billing-card {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .checkout-page {\n    background: #0a0c10 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .checkout-page h1,\n  .checkout-page h2,\n  .checkout-page p,\n  .checkout-page span,\n  .checkout-page li,\n  .checkout-page label {\n    color: #e2e8f0 !important;\n  }\n\n  .summary-desc,\n  .benefit-detail,\n  .payment-subtitle,\n  .billing-note,\n  .selector-label,\n  .billing-card-detail {\n    color: #94a3b8 !important;\n  }\n\n  .summary-title,\n  .payment-title,\n  .benefit-label,\n  .account-email,\n  .plan-card-name,\n  .billing-card-name,\n  .plan-card-price,\n  .breakdown-row.total,\n  .payment-line.total {\n    color: #f8fafc !important;\n  }\n}\n\n// ── Responsive ──\n@media (max-width: 900px) {\n  .checkout-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .payment-panel {\n    position: static;\n  }\n}\n\n@media (max-width: 600px) {\n  .checkout-page {\n    padding: calc(56px + 16px) 16px 32px;\n  }\n\n  .order-summary,\n  .payment-card {\n    padding: 1.25rem;\n  }\n\n  .summary-title {\n    font-size: 1.375rem;\n  }\n\n  .plan-cards,\n  .billing-cards {\n    grid-template-columns: 1fr;\n  }\n}\n\n.trial-badge {\n  display: inline-block;\n  margin: 0 0 0.75rem 0.5rem;\n  padding: 0.3rem 0.75rem;\n  border-radius: 999px;\n  background: #dcfce7;\n  color: #166534;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.trial-desc {\n  margin: 0.75rem 0 0;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  background: rgba(94, 161, 216, 0.08);\n  color: #374151;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.included-section--trial {\n  padding: 1rem 1.1rem;\n  border-radius: 12px;\n  border: 1px solid rgba(22, 163, 74, 0.22);\n  background: rgba(220, 252, 231, 0.45);\n\n  .included-heading {\n    color: #166534;\n  }\n\n  .benefit-icon {\n    color: #15803d;\n  }\n}\n\n.trial-after-note {\n  margin: 0.85rem 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n  color: #6b7280;\n}\n\n.payment-total--free {\n  color: #15803d !important;\n}\n\n.trial-pay-note {\n  color: #166534 !important;\n}\n\n.paypal-trial-unavailable {\n  margin: 0;\n  padding: 0.9rem 1rem;\n  border-radius: 10px;\n  border: 1px solid rgba(217, 119, 6, 0.35);\n  background: #fffbeb;\n  color: #92400e;\n  font-size: 0.875rem;\n  line-height: 1.45;\n}\n\n.trial-consent {\n  display: flex;\n  gap: 0.6rem;\n  align-items: flex-start;\n  margin: 1rem 0;\n  font-size: 0.85rem;\n  line-height: 1.45;\n  color: #374151;\n  cursor: pointer;\n\n  input {\n    margin-top: 0.2rem;\n    flex-shrink: 0;\n  }\n}\n\n.trial-manage-panel {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  margin-bottom: 1.25rem;\n  padding: 0.9rem 1.1rem;\n  border: 1px solid rgba(94, 161, 216, 0.35);\n  border-radius: 12px;\n  background: rgba(94, 161, 216, 0.08);\n\n  .material-icons {\n    color: #4a92c8;\n  }\n\n  .trial-manage-text {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    flex: 1;\n    font-size: 0.9rem;\n    color: #374151;\n  }\n\n  .trial-cancel-btn {\n    border: 1px solid #d1d5db;\n    background: #fff;\n    color: #b91c1c;\n    font-weight: 600;\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n    cursor: pointer;\n\n    &.emphasis {\n      border-color: #b91c1c;\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: default;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
